import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { colors, theme } from "@talkouttech/portal-shared";

export const Container = styled(Box)`
  border: 1px solid ${colors.primary};
  border-radius: ${theme.borderRadius.small}px;
`;
